import React, { useState, useEffect, useRef } from "react";
// import { useShoppingCart } from 'use-shopping-cart'
import { useCart } from './CartContext';

import { useParams, Link } from "react-router-dom";
import '../styles/cart.css';
import axios from 'axios';
import {Document, Page} from "react-pdf";
import config from '../config';
import { loadStripe } from "@stripe/stripe-js";
import { getCurrentUser } from 'aws-amplify/auth';

import { LuPencil } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { LuShoppingCart } from "react-icons/lu";

const host = config.backendUrl;
const stripePromise = loadStripe("pk_test_51QkZfKRqLIskEgXzaJ1JB4UL8D5pA9dhckvkXPt2uJpDyTFIM61Eo1pKMQjDj331mTKk4I2sE3QqiORGgT4DPp1S00KjOjMeRM");

export default function Cart({title}) {
    const [error, setError] = useState(null);
    const [checkoutDisabled, setCheckoutDisabled] = useState(true);
    const [user, setUser] = useState(null);
    const { cart, discount, cartCount, formattedTotalPrice, incrementItem, decrementItem, removeItem, updateQuantity, totalPrice, applyDiscount, removeDiscount, discountAmount } = useCart();

    useEffect(() => {
        document.title = title;

        const fetchUser = async () => {
            try {
                const currentUser = await getCurrentUser();
                if (currentUser) {
                    setUser(currentUser);
                } else {
                    setUser(null);
                }
            } catch (error) {
                console.error("Error fetching user:", error);
                setUser(null);
            }
        };

        fetchUser();
    }, []);

    const handleCheckout = async (cart) => {
        try {
          const payload = {
            items: cart,
            discount: Object.keys(discount).length > 0 ? {
                ...discount,
                // excludeShipping: (totalPrice() === 0 || Number(discountAmount()) === 9.99) ? true : false
                excludeShipping: totalPrice() === 0 ? true : false
            } : {},
          }

          if (user) {
            payload.user_id = user.userId; // Assuming user ID is stored in the sub attribute
          }

          const response = await fetch(`${host}/api/create-checkout-session`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-API-Key": process.env.REACT_APP_GANDF_KEY },
            body: JSON.stringify(payload),
          });

          const { url } = await response.json();
      
          if (url) {
            window.location.href = url; // Redirect user to Stripe Checkout
          }
        } catch (error) {
          console.error("Error creating checkout session:", error);
        }
    };

    const checkPromoCode = async () => {
        const promoCode = document.getElementById("promo-code").value;
        if (promoCode === "") {
            alert("Please enter a promo code");
            return;
        }

        try {
            const response = await fetch(`${host}/api/check-promo-code/${promoCode}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", "X-API-Key": process.env.REACT_APP_GANDF_KEY },
            });
            const data = await response.json();
            if (data.valid) {
                applyDiscount(data);
            } else {
                console.log(discount)
                alert("Invalid promo code");
            }
        }
        catch (error) {
            console.error("Error checking promo code:", error);
        }
    }

    return (
        <div className="cart">
            <div className="cart-header">
                <a className="cart-back-link" href="https://grieversandfriends.com/books/">&larr;  Back to Products</a>
                <h1>Your Cart ({cartCount})</h1>
            </div>


            {cart.length === 0 && (
                <div className="empty-cart">
                    <LuShoppingCart className="empty-cart-icon" />
                    <p className="empty-cart-header">Your cart is empty</p>
                    <p className="empty-cart-text">Looks like you haven't added any products yet.</p>
                    <Link to="/" className="empty-cart-button">Browse Products</Link>
                </div>
            )}

            {cart.length > 0 && (
                <div className="cart-body">
                    <div className="cart-items">
                        {cart.map((item) => (
                            <div className="cart-item" key={item.id}>
                                <img src={item.image} className="cart-item-image" />

                                <div className="cart-item-text">
                                    <div className="cart-item-header">
                                        <p className="product-name">{item.name}</p>
                                        <Link className="product-edit-link" to={`/books/${item.readable_id}/preview/${item.id}`}><LuPencil /> Edit</Link>
                                    </div>
                                    <p className="product-recipient">{item.choices.bookType} - {item.choices.recipient}</p>

                                    <div className="cart-item-amount">
                                        <button 
                                            onClick={() => decrementItem(item.id)} 
                                            className="cart-item-amount-minus"
                                            disabled={item.quantity === 1}
                                        >
                                            <div>
                                                <span>&#8722;</span>
                                            </div>
                                        </button>
                                        <p className="cart-item-amount-number">{item.quantity}</p>
                                        <button onClick={() => incrementItem(item.id)} className="cart-item-amount-plus">
                                            <div>
                                                <span>&#43;</span>
                                            </div>
                                        </button>
                                    </div>

                                    <div className="item-footer">
                                        <button onClick={() => removeItem(item.id)} className="cart-item-remove"><FaRegTrashCan /><p>Remove Item</p></button>
                                        <div className="product-price-div">
                                            <p className="product-price">${((item.price / 100) * item.quantity).toFixed(2)}</p>
                                            {item.quantity > 1 && <p className="product-price-each">${(item.price / 100)} each</p>}
                                        </div>
                                    </div>
                                </div>
            
                            </div>
                        ))}


                    </div>

                    <div className="cart-total">
                        {/* Map through the cart items and calculate the total price */}
                        {cart.map((item) => {
                            return (
                                <div className="cart-text" key={item.id}>
                                    <p>{item.name} (x{item.quantity})<br/>
                                    <span className="cart-item-subheader">{item.choices.bookType}</span></p>
                                    <p>${((item.price / 100) * item.quantity).toFixed(2)}</p>
                                </div>
                            )
                        })}

                        {Object.keys(discount).length > 0 && (
                            <div className="cart-text discount">
                                <div className="discount-text">
                                    <button className="remove-discount" onClick={() => removeDiscount()}>&#x2715;</button>
                                    <p>Discount</p>
                                </div>
                                <p>-${discountAmount()}</p>
                            </div>
                        )}

                        <div className="cart-text">
                            <p>Shipping & Tax</p>
                            <p>Calculated at checkout</p>
                        </div>

                        <hr className="cart-divider" />

                        <div className="cart-text">
                            <p><strong>Subtotal</strong></p>
                            <p><strong>{formattedTotalPrice}</strong></p>
                        </div>

                        <hr className="cart-divider" />

                        <div className="promo-code">
                            <label for="promo-code" className="promo-code-label">Enter a Promo Code</label>
                            <div className="promo-code-input-container">
                                <input id="promo-code" type="text" className="promo-code-input" placeholder="Promo Code" />
                                <button className="promo-code-button" onClick={() => checkPromoCode()}>Apply</button>
                            </div>
                        </div>

                        <hr className="cart-divider" />

                        <button className="checkout-button" onClick={() => handleCheckout(cart)}>Proceed to Checkout</button>

                        <div className="cart-disclaimer-container">

                            <div className="cart-disclaimer">
                                <label for="disclaimer-2" className="cart-disclaimer-text">By proceeding to checkout, I confirm that I have read and agree to the <a href="https://grieversandfriends.com/terms" target="_blank">Terms of Use</a> and <a href="https://grieversandfriends.com/privacy" target="/blank">Privacy Policy</a>.</label>
                            </div>
                        </div>
                    </div>
                
                </div>
            )}

        </div>
    );
}